'use strict';

var React = require('react');

/**
 * Internal, exported only for usage in Framer
 */
const SwitchLayoutGroupContext = React.createContext({});

exports.SwitchLayoutGroupContext = SwitchLayoutGroupContext;
//# sourceMappingURL=SwitchLayoutGroupContext.cjs.map
